module.exports = __webpack_public_path__ + "img/16.238fa585.png";